"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
var getUserPreviousItemsCount_1 = require("@/react-app/common/utils/getUserPreviousItemsCount");
var useIntersectionObserver_1 = require("@/react-app/common/hooks/useIntersectionObserver");
function UserPreviousItemsCount(_a) {
    var _this = this;
    var currentUserId = _a.currentUserId, domain = _a.domain, isOpenInNewTab = _a.isOpenInNewTab, angularJsDependencies = _a.angularJsDependencies, viewType = _a.viewType;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read((0, react_1.useState)(new AbortController()), 1), controller = _b[0];
    var _c = __read((0, react_1.useState)([]), 2), userPreviousItemsCountArray = _c[0], setUserPreviousItemsCountArray = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), userCountFetched = _d[0], setUserCountFetched = _d[1];
    // TO DO move this logic to the backend and fetch user count for all items before returning the list of items
    var handleUserPreviousItemsCount = function () { return __awaiter(_this, void 0, void 0, function () {
        var userPreviousItemsCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, getUserPreviousItemsCount_1.getUserPreviousItemsCount)(domain, currentUserId, controller)];
                case 1:
                    userPreviousItemsCount = _a.sent();
                    setUserPreviousItemsCountArray(userPreviousItemsCount);
                    setUserCountFetched(true);
                    return [2 /*return*/];
            }
        });
    }); };
    // make sure it loads around 10 ads when opening the page
    var rootMargin = viewType === 'list' ? '1200px' : '4000px';
    var itemRef = (0, react_1.useRef)(null);
    var intersectionObserverEntry = (0, useIntersectionObserver_1.useIntersectionObserver)(itemRef, 
    // to be able to test the intersection observer, we need to set the rootMargin to -100px (to see two items in the viewport but only one counter is running)
    // rootMargin: '10px' to start running the counter when the item is 10px before the viewport
    { rootMargin: rootMargin }, true);
    var _e = intersectionObserverEntry || {}, isIntersecting = _e.isIntersecting, intersectedTarget = _e.target;
    (0, react_1.useEffect)(function () {
        setUserCountFetched(false);
        if (!isIntersecting || !intersectedTarget) {
            return;
        }
        handleUserPreviousItemsCount();
    }, [isIntersecting, currentUserId]);
    (0, react_1.useEffect)(function () {
        return function () {
            controller.abort();
        };
    }, []);
    var isNewUser = userPreviousItemsCountArray.every(function (item) { return item.count === 0; });
    return (react_1.default.createElement("div", { className: "eva-user-previous-items-count eva-user-previous-ads-count-container", ref: itemRef },
        isNewUser && userCountFetched && (react_1.default.createElement("span", { className: "eva-user-previous-ads-count__new-user", title: t('ITEM.NEW_USER_TOOLTIP') }, t('ITEM.NEW_USER_LABEL'))),
        !isNewUser && userCountFetched && (react_1.default.createElement("span", null, userPreviousItemsCountArray.map(function (item) { return (react_1.default.createElement("a", { key: item.status, target: isOpenInNewTab ? '_blank' : '_self', className: (0, clsx_1.default)("eva-user-previous-ads-count__".concat(item.status), {
                'eva-user-previous-ads-count--empty': item.count === 0,
            }), href: angularJsDependencies.href('app.assignment.search', {
                filters: encodeURIComponent(item.filters.map(function (filter) { return "".concat(filter.id, ":").concat(filter.value); }).join(',;,')),
                status: item.status,
                cursor: null,
            }), rel: "noreferrer" },
            item.count,
            react_1.default.createElement("span", { className: "eva-tooltip eva-tooltip-user-previous-item-count" },
                react_1.default.createElement("span", { className: "eva-user-previous-ads-count__tooltip-status" }, "".concat(item.tooltip, " ")),
                react_1.default.createElement("span", { className: "eva-user-previous-ads-count__tooltip-number" }, item.countInPercentage)))); })))));
}
exports.default = UserPreviousItemsCount;
